const utils = require('../utils.js');

const pubsub = window.DR.pubsub;

function fixedToolbar() {
  const $window = $(window);
  const body = document.body;
  const $body = $(body);
  let backTop = null;
  const $header = $('#header');
  const updateActive = function(dims) { // eslint-disable-line func-style
    return dims.width < 1025 && !$body.hasClass('navActived') && !$body.hasClass('oldAndroid');
  };
  let active = updateActive(utils.viewport());
  pubsub.on('resize', (dims) => {
    active = updateActive(dims);
  });

  pubsub.on('scroll', (dims) => {
    if (!active) {
      return;
    }

    if (!backTop) {
      backTop = $(
        '<a class="hidden" id="backTop" title="Back to top" href="#wrapper">' +
          '<i class="icon-arrow-up"></i>' +
        '</a>'
      );
      backTop.appendTo($body);
    }

    // bc. compare panel from session is rendered before backToTop button
    const $comparePanel = $('.dc-compare-panel') || null;
    if ($comparePanel) { backTop.addClass('withCompare'); }

    if ($window.scrollTop() > 46 && utils.viewport().width < 1025) {
      $header.css({ top: `${-$header.height()}px` });
      $header.addClass('header--sticky');
      backTop.removeClass('hidden');
    } else {
      $header.css({ top: 0 });
      $header.removeClass('header--sticky');
      backTop.addClass('hidden');
    }
  });
}

module.exports = fixedToolbar;
